import React from "react";
import { Card } from "@aidnas/design-system";
import clsx from "clsx";

import { useChatContext } from "../context/ChatContext";

import { ChatHeader } from "./ChatHeader";
import { ChatInput } from "./ChatInput";
import { ChatMessages } from "./ChatMessages";

import styles from "../Styles.module.scss";

export function ChatSidebar() {
  const { isOpen } = useChatContext();

  return (
    <div className={clsx(styles.sidebar, isOpen && styles.sidebar_open)}>
      <Card className={styles.card}>
        <div className={styles.close_row}>
          <ChatHeader />
        </div>
        <ChatMessages />
        <ChatInput />
      </Card>
    </div>
  );
}
